/**
 * Stałe i helpery dla obszaru Dokumenty (F20) — systemowe slugi modułów
 * mapujące na 7 klas dokumentów (6 + „specjalne").
 *
 * Używane w:
 *  - AdditionalTableConfigPanel (SystemModuleBuilderPage) — filtr tabel dodatkowych
 *    tak by tabele z parentEntity='documents' były widoczne w builderze każdego
 *    z 7 modułów dokumentowych (Wariant A: jedna wspólna definicja per obszar).
 *
 * WAŻNE: lista musi być zsynchronizowana z seed-system-modules.ts
 * (backend) i seed-pub (kartoteki). Nie zmieniaj slug-ów bez migracji.
 */

/** Slugi modułów systemowych odpowiadających 7 klasom dokumentów (F20 + „specjalne"). */
export const DOCUMENT_MODULE_SLUGS = new Set([
  'purchase_invoices',
  'sale_invoices',
  'contracts',
  'letters',
  'commercial',
  'internal',
  'specjalne',
]);

/** parentEntity używane przez tabele dodatkowe należące do obszaru Dokumenty. */
export const DOCUMENTS_PARENT_ENTITY = 'documents' as const;

// ─── Helper: filter tabel dodatkowych per moduł ───────────────────────────────

/**
 * Filtruje listę tabel dodatkowych tak by zwrócić tylko te należące do
 * podanego modułu systemowego.
 *
 * Zasady (Wariant A — Etap 1 Dokumenty):
 *  1. Tabela z parentEntity === moduleSlug → zawsze widoczna (standardowy match).
 *  2. Tabela z parentEntity === 'documents' → widoczna gdy moduleSlug jest jednym
 *     z 7 modułów dokumentowych (DOCUMENT_MODULE_SLUGS). Dzięki temu jedna
 *     tabela zdefiniowana dla obszaru Dokumenty pojawia się we wszystkich
 *     7 modułach — i w żadnym innym.
 *
 * Constraint T extends { parentEntity: string } bez index signature —
 * unika problemu z unknown dla pozostałych pól (tbl.id, tbl.slug, …).
 *
 * Funkcja jest czysto funkcyjna (pure) — testowalna bez mockowania React.
 */
export function filterAdditionalTablesForModule<T extends { parentEntity: string }>(
  tables: T[],
  moduleSlug: string,
): T[] {
  return tables.filter(
    (tbl) =>
      tbl.parentEntity === moduleSlug ||
      (tbl.parentEntity === DOCUMENTS_PARENT_ENTITY && DOCUMENT_MODULE_SLUGS.has(moduleSlug)),
  );
}
